import { guardArray } from "../array";
import { moment } from "../date";
import type { AttendanceList, AttendanceListItem, AttendanceSectionList, Nullable } from "../types";

export function getPersonioLiveAttendanceState(
	__attendances: Nullable<AttendanceList | AttendanceSectionList>,
) {
	const _attendances = guardArray(__attendances as any);
	const attendances = (
		"title" in (_attendances?.[0] ?? {})
			? _attendances.flatMap((section) => section.data)
			: (_attendances ?? [])
	) as AttendanceList;

	const lastAttendance = attendances?.[0] as AttendanceListItem | undefined;

	let isLive = false;
	let liveSince: string | null = null;
	let liveAttendanceType: AttendanceList[number]["type"] | null = null;

	if (lastAttendance) {
		if (!lastAttendance.endTime) {
			if (lastAttendance.startTime) {
				const startMoment = moment(lastAttendance.startTime);
				if (
					startMoment.isAfter(moment().subtract(24, "hours")) &&
					startMoment.isSame(moment(), "date")
				) {
					isLive = true;
					liveSince = lastAttendance.startTime;
					liveAttendanceType = lastAttendance.type;
				}
			}
		}
	}

	return {
		isLive,
		liveSince,
		liveAttendanceType,
		liveAttendance: isLive ? lastAttendance : undefined,
	};
}
